import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import PageConH5 from '@/components/ProductDelta/Delta2new/Delta2H5';
import PageConPc from '@/components/ProductDelta/Delta2new/Delta2Pc';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import Annotation from '@/components/Annotation';

// 产品详情页参数
const productName = 'delta-2-portable-power-station';
const generalKey = 'product_ps_delta_delta_2';
const theme = 'black';

export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useLang } = useGlobal();
    const router = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const { locale = 'us' } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    // 如果不存在该页面,返回404
    // if (typeof window !== 'undefined' && !productMsg.generalKey && gloproductlist.length) {
    //     return router.push('/404');
    // }
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    return (
        <>
            <SEO title={productMsg.title || t('seo_title')} description={productMsg.description || t('seo_desc')} />
            <SEOlinksA
                list={['us', 'jp', 'cn', 'ca', 'uk', 'de', 'fr', 'it', 'es', 'za', 'cis', 'eu', 'au', 'tw', 'kr', 'sa', 'br', 'mx', 'ph', 'nl']}
                locale={locale}
                pathname={productMsg.url}
            />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon theme={theme} />
                    <Annotation borderTopColor="transparent" bgColor="#000" boxStyle={isMobile ? {} : { width: '1120px' }} />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}
